import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  application: FormGroup;

  constructor(
    public authService: AuthService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.application = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  onSubmitForm() {
    if (this.application.valid) {
      let email = this.application.get('email').value;
      let password = this.application.get('password').value;

      try {
        this.authService.login(email, password);
        this.authService.logInFailure &&
          this.snackBar.open('Invalid credentials', '', {
            duration: 3000,
          });
      } catch (error) {
       this.authService.logInFailure && this.snackBar.open('Invalid credentials', '', {
          duration: 3000,
        });
      }
    } else {
      this.snackBar.open('Please fill in your credentials', '',{
        duration: 3000,
      });
    }
  }
}
